(function () {
	var openItem = null;
	var scrollStartY = 0;

	// See kc-search.js for the definition - whichever file loads first wins.
	// Reference-counted so this panel and the search panel can't clobber
	// each other's "make the header solid" state during a hand-off.
	window.__kcOpenPanels = window.__kcOpenPanels || {};
	window.__kcSetHeaderSolid = window.__kcSetHeaderSolid || function (name, isOpen) {
		window.__kcOpenPanels[name] = isOpen;
		var headerSection = document.querySelector('.header-section');
		if (!headerSection) return;
		var anyOpen = Object.keys(window.__kcOpenPanels).some(function (key) {
			return window.__kcOpenPanels[key];
		});
		headerSection.classList.toggle('mega-menu-active', anyOpen);
	};

	function isDesktop() {
		return window.matchMedia('(min-width: 1024px)').matches && window.matchMedia('(hover: hover)').matches;
	}

	function closeItem(item, focusTrigger) {
		if (!item) return;
		item.classList.remove('is-open');
		var trigger = item.querySelector('[data-kc-nav-trigger]');
		var panel = item.querySelector('[data-kc-mega]');
		if (trigger) trigger.setAttribute('aria-expanded', 'false');
		if (panel) panel.hidden = true;
		// Only clear the header's solid-white state if we're closing the
		// item that's actually tracked as open. A deferred close (the
		// mouseleave rAF check below) can fire *after* the pointer has
		// already moved to a different top-level item and opened it -
		// blindly clearing here would undo that item's own solidify call,
		// flickering the header back to transparent.
		if (item === openItem) {
			openItem = null;
			window.__kcSetHeaderSolid('megamenu', false);
			document.documentElement.classList.remove('kc-mega-open');
		}
		if (focusTrigger && trigger) trigger.focus();
	}

	function positionPanel(item) {
		var trigger = item.querySelector('[data-kc-nav-trigger]');
		var panel = item.querySelector('[data-kc-mega]');
		var container = item.closest('.header__container');
		if (!trigger || !panel || !container) return;
		var triggerRect = trigger.getBoundingClientRect();
		var containerRect = container.getBoundingClientRect();
		// Anchor the panel to the trigger's own rendered bottom edge rather
		// than a guessed `top: 100%`, so there is a real, mathematically
		// zero-pixel gap for the mouse to cross — not just a fast re-check
		// after the fact. Theme header padding varies by breakpoint/content,
		// so this is measured live instead of hard-coded.
		panel.style.top = (triggerRect.bottom - containerRect.top) + 'px';
	}

	function openItemFn(item) {
		if (openItem && openItem !== item) closeItem(openItem);
		positionPanel(item);
		item.classList.add('is-open');
		var trigger = item.querySelector('[data-kc-nav-trigger]');
		var panel = item.querySelector('[data-kc-mega]');
		if (trigger) trigger.setAttribute('aria-expanded', 'true');
		if (panel) panel.hidden = false;
		window.__kcSetHeaderSolid('megamenu', true);
		document.documentElement.classList.add('kc-mega-open');
		openItem = item;
		scrollStartY = window.scrollY;
		document.dispatchEvent(new CustomEvent('kc:panel:opened', { detail: { name: 'megamenu' } }));
	}

	function setActivePreview(panel, index) {
		var items = panel.querySelectorAll('.kc-mega__showcase-item[data-preview-index]');
		Array.prototype.forEach.call(items, function (el) {
			el.classList.toggle('is-active', el.getAttribute('data-preview-index') === index);
		});
	}

	function initPreviewSwap(panel) {
		var links = panel.querySelectorAll('.kc-mega__link[data-preview-index]');
		if (!links.length) return;

		Array.prototype.forEach.call(links, function (link) {
			link.addEventListener('mouseenter', function () {
				setActivePreview(panel, link.getAttribute('data-preview-index'));
			});
			link.addEventListener('focus', function () {
				setActivePreview(panel, link.getAttribute('data-preview-index'));
			});
		});
	}

	function initNavItem(item) {
		if (item.__kcMegaReady) return;
		item.__kcMegaReady = true;

		var trigger = item.querySelector('[data-kc-nav-trigger]');
		var panel = item.querySelector('[data-kc-mega]');
		if (!trigger || !panel) return;

		initPreviewSwap(panel);

		item.addEventListener('mouseenter', function () {
			if (!isDesktop()) return;
			openItemFn(item);
		});

		item.addEventListener('mouseleave', function () {
			if (!isDesktop()) return;
			// The panel sits below a gap of theme-controlled header padding
			// that isn't safe to zero out globally, so a fast mouse crossing
			// it registers as leaving `item` for a moment before it reaches
			// the panel. Re-check on the next frame (not a hover-intent
			// delay — this doesn't postpone opening, only avoids closing on
			// a single stale mouseleave) rather than closing right away.
			window.requestAnimationFrame(function () {
				if (!item.matches(':hover') && !panel.matches(':hover')) {
					closeItem(item);
				}
			});
		});

		trigger.addEventListener('keydown', function (event) {
			if (event.key === 'Enter' || event.key === ' ') {
				event.preventDefault();
				openItemFn(item);
				var firstLink = panel.querySelector('a');
				if (firstLink) firstLink.focus();
			} else if (event.key === 'ArrowDown') {
				event.preventDefault();
				openItemFn(item);
			} else if (event.key === 'Escape') {
				closeItem(item, true);
			}
		});

		item.addEventListener('keydown', function (event) {
			if (event.key === 'Escape' && item.classList.contains('is-open')) {
				closeItem(item, true);
			}
		});

		item.addEventListener('focusout', function (event) {
			window.setTimeout(function () {
				if (!item.contains(document.activeElement)) {
					closeItem(item);
				}
			}, 0);
		});
	}

	function initAll(scope) {
		scope = scope || document;
		Array.prototype.slice.call(scope.querySelectorAll('[data-kc-nav-item]')).forEach(initNavItem);
	}

	document.addEventListener('click', function (event) {
		if (!openItem) return;
		if (!openItem.contains(event.target)) {
			closeItem(openItem);
		}
	});

	document.addEventListener('scroll', function () {
		if (!openItem) return;
		if (Math.abs(window.scrollY - scrollStartY) > 10) {
			closeItem(openItem);
		}
	}, { passive: true });

	document.addEventListener('kc:panel:opened', function (event) {
		var opener = event.detail && event.detail.name;
		if (opener !== 'megamenu' && openItem) closeItem(openItem);
	});

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', function () { initAll(); });
	} else {
		initAll();
	}

	document.addEventListener('shopify:section:load', function (event) {
		initAll(event.target);
	});
})();
